/** Collect closing-cost input rows across HUD1 / Fee Worksheet / CD page shapes. */
export const getClosingCostInputRows = (inputs: Record<string, any> | null | undefined): any[] => {
  if (!inputs) return []
  if (Array.isArray(inputs.closingCosts)) return inputs.closingCosts

  const rows: any[] = []
  const seen = new Set<string>()
  Object.values(inputs).forEach((val) => {
    if (!Array.isArray(val)) return
    val.forEach((item: any) => {
      if (!item || item.lineId == null || !item.feeBKey) return
      const key = String(item.lineId)
      if (seen.has(key)) return
      seen.add(key)
      rows.push(item)
    })
  })
  return rows
}
